import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-radio-on",
  "use": "icon-radio-on-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"icon-radio-on\">\n<style type=\"text/css\">\n\t#icon-radio-on .st0{fill-rule:evenodd;clip-rule:evenodd;fill:currentColor;}\n</style>\n<path class=\"st0\" d=\"M512,739.6c125.7,0,227.6-101.9,227.6-227.6S637.7,284.4,512,284.4S284.4,386.3,284.4,512\n\tS386.3,739.6,512,739.6z M512,1024C229.2,1024,0,794.8,0,512S229.2,0,512,0s512,229.2,512,512S794.8,1024,512,1024z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/radio-on.svg
// module id = Og+d
// module chunks = 28